import { render, staticRenderFns } from "./ServicePointDetailHeader.vue?vue&type=template&id=c68e64e2&scoped=true&"
import script from "./ServicePointDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./ServicePointDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ServicePointDetailHeader.vue?vue&type=style&index=0&id=c68e64e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68e64e2",
  null
  
)

export default component.exports